import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import SimpleReactValidator from 'simple-react-validator';
import AsyncPaginate from "react-select-async-paginate";
import loadOptions from "../LoadOptions";
import DateTimePicker from "react-datepicker";// Start Date & Time picker
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Notifications, { notify } from 'react-notify-toast';
import axios from "../axiosApis";
import Context from '../../Context';
import Header from "../../Layouts/Header";
import Terms from "./Terms";
import {
  Col,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
var dateFormat = require("dateformat");
const curDate = new Date();
var cur_year = curDate.getFullYear();
// const addSubtractDate = require("add-subtract-date");

class EnrolmentForm extends Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      birthday: new Date(),
      minDate: new Date(),
      genderList: [
        { "value": "male", "label": "Male" },
        { "value": "female", "label": "Female" },
        { "value": "others", "label": "Others" }
      ],
      identification_types: [
        { "value": "national-id", "label": "National ID" },
        { "value": "passport-no", "label": "Passport No" },
      ],
      identification_type: { "value": "national-id", "label": "National ID" },
      education_status_list: [
        { "value": 'completed_primary', "label": "Completed Primary School" },
        { "value": 'completed_high', "label": "Completed High School" },
        { "value": 'completed_university', "label": "Completed University" },
        { "value": 'completed_masters', "label": "Completed Masters" },
        { "value": 'completed_doctorate', "label": "Completed Doctorate" }
      ],
      /*enrolment_types : [
        {"value":'direct',"label":"Direct"},
          {"value":'sponsored',"label":"Sponsored"},
      ],*/
      pre_course_types: [
        { "value": 'Yes', "label": "Yes" },
        { "value": 'No', "label": "No" },
      ],
      pre_course: "No",
      course: [],
      url: "/admission/",
      method: "POST",
      languages_known_ids: [],
      national_nb: "",
      zip: "",
      cleanBatch: 0,
      entrance_stu: [],
      name: "",
    }
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    // var minDate = new Date(addSubtractDate.subtract(new Date(`01-01-${cur_year}`), 15, "year"));
    let year = new Date().getFullYear();
    var minDate = new Date()
    minDate.setFullYear(year - 15)
    this.setState({
      birthday: minDate,
      minDate: minDate,
    })
  }

  handleCourse = (event) => {
    var cleanBatch = this.state.cleanBatch;
    var is_entrance_exam = event.code === true ? (this.fetchStuData(event.value)) : "";
    this.setState({
      course: event,
      cleanBatch: cleanBatch + 1,
      batch_id: "",
      stu_name: "",
      entrance_stu: [],
      entrance_status: false
    })
  }

  fetchStuData = (code) => {
    axios
      .get(`/entrance-exam/${code}`)
      .then(res => {
        var data = res.data && res.data.data || [];
        var entrance_stu = [];
        data && data.map(result => {
          var birthday = this.handleDateFormate(result.dob)
          entrance_stu.push({
            "label": result.name,
            "value": result.id,
            "phone": "20" + result.phone,
            "birthday": birthday
          })
        })
        this.setState({
          entrance_stu: entrance_stu,
          entrance_status: true
        })
      })
  }

  handleDateFormate = (birthday) => {
    var date1 = birthday.split('-')
    var newDate = date1[1] + '-' + date1[0] + '-' + date1[2];
    var date = new Date(newDate);
    return date;
  }

  handleEduData = (type, event) => {
    this.setState({
      [type]: event,
      "name": event && event.label || "",
      "birthday": event && event.birthday || "",
      "phone": event && event.phone || ""
    })
  }

  handleDropdownData = (type, event) => {
    this.setState({
      [type]: event
    })
  }

  formateArray = (data) => {
    var arrData = data.length > 1 ? { "label": data[1], "value": data[0] } : [];
    return arrData;
  }

  formateMulArr = (data) => {
    var arrData = data && data.map(res => {
      return { "label": res[1], "value": res[0] }
    })
    return arrData;
  }


  handleInput = (type, event) => {
    if (type === "name") {
      this.setState({
        stu_name_err: ""
      })
    }
    this.setState({
      [type]: event.target.value
    })
  }

  handleData = (event) => {
    if (this.state.app_confirm === 'yes') {
      this.setState({ app_confirm: 'no' })
    } else {
      this.setState({ app_confirm: 'yes' })
    }
  }

  handleDatePicker = (type, event) => {
    this.setState({
      [type]: event
    })
  }

  onDropImages = (formname, data) => {
    const { t } = this.props;
    var files = data.target.files;
    var file = files[0];
    if (files && file && file.size <= 500000) {
      var reader = new FileReader();
      var self = this;
      var fileName = formname + "_fileName";
      reader.onload = function (readerEvt) {
        var binaryString = readerEvt.target.result;
        self.setState({
          [formname]: btoa(binaryString)
        })
        self.setState({
          [fileName]: file.name,
        })
      };
      reader.readAsBinaryString(file);
    } else {
      let color = { background: '#ff0000', text: "#FFFFFF" };
      notify.show(t("imp_err"), "custom", 5000, color);
    }
  }

  handleIdBasedStu = (event) => {
    const { national_nb, stu_status, cur_status } = this.state;
    if (national_nb.length > 4 && stu_status !== "Success" && stu_status !== "Error") {
      var url = `/student/${national_nb}/`;
      this.context.updateValue && this.context.updateValue("val", url);
      var self = this;
      window.setTimeout(function () {
        var stu_data = self.context;
        var data = stu_data && stu_data.state && stu_data.state.val || [];
        //console.log(data);
        if (Object.entries(data).length > 0) {
          var datas = data && data.data || [];
          var birthday = datas && datas.birthday ? (self.handleDateFormate(datas.birthday)) : "";
          if (birthday !== "" && birthday !== undefined) {
            //console.log("inn");
            var status = data && data.msg || false;
            var nationality_id = self.formateArray(datas && datas.nationality_id || []);
            var educational_status = self.formateArray(datas && datas.educational_status || []);
            var mother_tongue_id = self.formateArray(datas && datas.mother_tongue_id || []);
            var gender = datas && datas.gender && datas.gender[0] || "";
            var languages_known_ids = self.formateMulArr(datas && datas.languages_known_ids || []);
            self.setState({
              stu_status: status,
              cur_status: "Success",
              ...datas,
              birthday: new Date(birthday),
              nationality_id: nationality_id,
              mother_tongue_id: mother_tongue_id,
              educational_status: educational_status,
              gender: gender,
              languages_known_ids: languages_known_ids
            })
          } else if (cur_status === "Success") {
            //console.log("inn1");
            self.setState({
              stu_status: "Error",
              cur_status: "Error",
              apartment_no: "",
              birthday: new Date(),
              city: "",
              educational_status: [],
              email: "",
              gender: "",
              governorate: "",
              languages_known_ids: [],
              name: "",
              nationality_id: [],
              mother_tongue_id: [],
              passport_nb: "",
              phone: "",
              regional_name: '',
              zip: ''
            })
          } else {
            //console.log("inn2");
            self.setState({
              stu_status: "Error",
              cur_status: "Error"
            })
          }
        }
      }, 500)
    }
  }

  handleNumInput = (type, event) => {
    var regexp = /^[0-9\b]+$/;
    let slab_fee = event.target.value;
    if (type === "national_nb") {
      this.setState({
        stu_status: false
      })
    }
    console.log('this.state.identification_type?.value: ', this.state.identification_type?.value);
    if (slab_fee === '' || regexp.test(slab_fee) || this.state.identification_type?.value === 'passport-no') {
      this.setState({ [type]: slab_fee })

    }
  }

  handleSubmit = (event) => {
    const { t } = this.props;
    // if (this.state.app_confirm !== "yes") {
    //   this.setState({
    //     app_confirm_err: "Application Confirmation is required",
    //   })
    //   let color = { background: '#ff0000', text: "#FFFFFF" };
    //   notify.show("Please fill out all the mandatory fields.", "custom", 5000, color);
    //   return false;
    // }
    if (this.validator.allValid()) {
      var data = this.state;
      var stu_name = this.state.stu_name;
      var stu_id = stu_name && stu_name.value || "";
      if ((this.state.entrance_status === true && stu_id === "") || data.name === "") {
        let color = { background: '#ff0000', text: "#FFFFFF" };
        notify.show(t("val_err"), "custom", 3000, color);
        this.setState({
          stu_name_err: "The name field is required"
        })
        return false;
      }
      var languages_known_id = [];
      data.languages_known_ids.length > 0 && data.languages_known_ids.map(res => {
        languages_known_id.push(res.value);
      })
      var course_student_id = data.stu_name && data.stu_name.value || "";

      var image_1920 = data.profile_img
      var ext_datas = {
        image_1920,
        course_student_id
      }
      ext_datas = Object.entries(ext_datas).reduce((a, [k, v]) => ((v == '' || v == undefined) ? a : (a[k] = v, a)), {});
      var datas = {
        name: data.name,
        regional_name: data.regional_name,
        birthday: dateFormat(data.birthday, "dd-mm-yyyy"),
        gender: data.gender,
        batch_id: data.batch_id && data.batch_id.value || "",
        nationality_id: data.nationality_id && data.nationality_id.value || "",
        national_nb: data.national_nb,
        // identification_type: data.identification_type.value,
        //passport_nb: data.passport_nb,
        educational_status: data.educational_status && data.educational_status.value || "",
        mother_tongue_id: data.mother_tongue_id && data.mother_tongue_id.value || "",
        languages_known_ids: languages_known_id,
        apartment_no: data.apartment_no && data.apartment_no || "",
        city: data.city,
        governorate: data.governorate,
        zip: data.zip,
        phone: data.phone,
        mobile: data.mobile,
        email: data.email,
        ...ext_datas
      }
      axios(data.url, {
        method: data.method,
        timeout: 100000,
        data: { "params": datas },
        headers: {
          'Content-Type': 'application/json',
          'accept': '*/*'
        }
      }).then(result => {
        var error_code = result &&
          result.data &&
          result.data.result &&
          result.data.result.msg || result;
        if (error_code === "Success") {
          var userDetails = result &&
            result.data &&
            result.data.result &&
            result.data.result.data || {};
          var self = this;
          let color = { background: '#32CD32', text: "#FFFFFF" };
          notify.show(t("form_suc"), "custom", 2000, color);
          if (Object.entries(userDetails).length > 0) {
            localStorage.setItem("stuData", JSON.stringify(userDetails));
            window.setTimeout(function () {
              self.props.history.push("/success")
            }, 2000)
          }
        } else {
          this.handleFetchError(result);
        }
      }).catch(error => {
        this.handleFetchError(error)
      })
    } else {
      let color = { background: '#ff0000', text: "#FFFFFF" };
      notify.show(t("val_err"), "custom", 5000, color);
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  handleFetchError = (error) => {
    var data = error && error.data || error;
    var errorMsg = data &&
      data.error &&
      data.error.data &&
      data.error.data.arguments ?
      data.error.data.arguments[0]
      :
      data &&
        data.result &&
        data.result.msg ?
        data.result.msg
        :
        data &&
          data.error &&
          data.error.data &&
          data.error.data.message ?
          data.error.data.message
          :
          "Server is down . Try again later.";
    let color = { background: '#ff0000', text: "#FFFFFF" };
    notify.show(errorMsg, "custom", 3000, color);
  }

  handlePopUp = (event) => {
    this.setState({
      modal: false
    })
  }

  render() {
    console.log('*********************************', this.state.identification_type)

    const { t } = this.props;
    const { course,
      minDate,
      modal,
      identification_type
    } = this.state;
    var type = sessionStorage.getItem("language") !== null ? sessionStorage.getItem("language") : "ltr";
    var label_style = type === "rtl" ? "float-md-left" : "float-md-right";
    var unique_identification_type = identification_type.value === "national-id" ? "national_no_pla" : "passport_no_lbl";
    var unique_identification_lbl = identification_type.value === "national-id" ? "nationality_no_lbl" : "passport_no_pla";
    var identification_err_msg = identification_type.value === "national-id" ? "national id number" : "passport id number";

    return (
      <form onSubmit={e => { e?.preventDefault(); this.handleSubmit() }}>
        <Header data={"Status"} />
        <div style={{
          background: "#03204e",
          /*background: "-webkit-linear-gradient(to right, #03204e, #348F50)",
          background: "linear-gradient(to right, #03204e, #348F50)"*/
        }}>
          <br />

          {modal === true ? <Terms handleFunction={this.handlePopUp} /> : ""}

          <Notifications options={{ left: '50px', top: '200px' }} />
          <div className="card mb-3 ml-5 mr-5 mt-3" >
            <div className="card-header text-center border-success">
              <div className="row">
                <div className="col-md-12">
                  <h5 className="m-0"><strong><center>{t("enrol_head")}</center></strong></h5>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("applied_course_lbl")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-3 form-group">
                  <AsyncPaginate
                    value={this.state.course}
                    placeholder={t("applied_course_select")}
                    loadOptions={loadOptions}
                    onChange={this.handleCourse.bind('this')}
                    additional={{
                      endPoint: '/course/',
                    }}
                  />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('course', this.state.course, 'required')}</span>
                </div>
                <div className="col-md-3 form-group">
                  <AsyncPaginate
                    cacheUniq={this.state.cleanBatch}
                    value={this.state.batch_id}
                    placeholder={t("applied_batch_select")}
                    loadOptions={loadOptions}
                    onChange={this.handleDropdownData.bind('this', "batch_id")}
                    additional={{
                      endPoint: course && course.value ? `/batch/${course.value}/` : false,
                    }}
                  />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('batch', this.state.batch_id, 'required')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("identification_type")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-6 form-group">
                  <Select
                    value={this.state.identification_type}
                    options={this.state.identification_types}
                    onChange={this.handleDropdownData.bind('this', "identification_type")}
                  />
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t(unique_identification_type)}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-6 form-group">
                  {
                    this?.state?.identification_type?.value === 'national-id' ? <>
                      <input type="text" required className="form-control" id="national_nb" value={this.state.national_nb} onMouseLeave={this.handleIdBasedStu.bind(this)} onChange={this.handleNumInput.bind(this, "national_nb")} placeholder={t(unique_identification_lbl)} autocomplete="new_national_nb" name="national_nb" maxLength='14' />
                      <span style={{ color: "#ff0000" }}>{this.validator.message(identification_err_msg, this.state.national_nb, `integer|size:14`)}</span>
                    </> : <>
                      <input type="text" required className="form-control" id="national_nb" value={this.state.national_nb} onMouseLeave={this.handleIdBasedStu.bind(this)} onChange={this.handleNumInput.bind(this, "national_nb")} placeholder={t(unique_identification_lbl)} autocomplete="new_national_nb" name="national_nb" />
                      <span style={{ color: "#ff0000" }}>{this.validator.message(identification_err_msg, this.state.national_nb, `max:20`)}</span>
                    </>


                  }

                </div>
              </div>
              {
                this.state.entrance_status === true ?
                  <div className="row ml-5">
                    <div className="col-md-3 form-group">
                      <label className={`${label_style}`}><b>{t("entrance_name")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                    </div>
                    <div className="col-md-6 form-group">
                      <Select
                        value={this.state.stu_name}
                        options={this.state.entrance_stu}
                        placeholder={t("entrance_name_lbl")}
                        onChange={this.handleEduData.bind('this', "stu_name")}
                      />
                      <span style={{ color: "#ff0000" }}>{this.state.stu_name_err}</span>
                    </div>
                  </div>
                  :
                  <div className="row ml-5">
                    <div className="col-md-3 form-group">
                      <label className={`${label_style}`}><b>{t("name_lbl_eng")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                    </div>
                    <div className="col-md-6 form-group">
                      <input type="text" class="form-control" autocomplete="new_name" id="name" value={this.state.name} onChange={this.handleInput.bind(this, "name")} placeholder={t("name_pla_end")} name="name" maxLength="75" />
                      <span style={{ color: "#ff0000" }}>{this.state.stu_name_err}</span>
                    </div>
                  </div>
              }
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("name_lbl_arb")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-6 form-group">
                  <input type="text" class="form-control" autocomplete="new_regional_name" id="regional_name" value={this.state.regional_name} onChange={this.handleInput.bind(this, "regional_name")} placeholder={t("name_pla_arb")} name="regional_name" maxLength="75" />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('arabic name', this.state.regional_name, 'required')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("dob_lbl")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-6 form-group">
                  <DateTimePicker
                    selected={this.state.birthday}
                    // minDate={new Date()}
                    maxDate={minDate}
                    dateFormat="dd/MM/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    timeCaption="time"
                    className="form-control"
                    onChange={this.handleDatePicker.bind(this, "birthday")}
                  />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('DOB', this.state.birthday, 'required')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("gender_lbl")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-6 form-group">
                  {this.state.genderList.map(res => {
                    return (
                      <label className="radio-inline ml-2">
                        <input className="mr-1" type="radio" id="gender" name="gender" value={res.value} checked={this.state.gender === res.value} onChange={this.handleInput.bind(this, "gender")} />
                        {res.label}
                      </label>
                    )
                  })
                  }
                  <span style={{ color: "#ff0000" }}>{this.validator.message('gender', this.state.gender, 'required')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("nationality_lbl")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-6 form-group">
                  <AsyncPaginate
                    value={this.state.nationality_id}
                    placeholder={t("nationality_selct")}
                    loadOptions={loadOptions}
                    onChange={this.handleDropdownData.bind('this', "nationality_id")}
                    additional={{
                      endPoint: '/nationality/',
                    }}
                  />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('nationality', this.state.nationality_id, 'required')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("education_status")}</b>&nbsp;&nbsp;</label>
                </div>
                <div className="col-md-6 form-group">
                  <Select
                    value={this.state.educational_status}
                    options={this.state.education_status_list}
                    placeholder={t("education_select")}
                    onChange={this.handleDropdownData.bind('this', "educational_status")}
                  />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('Educational Status', this.state.educational_status, 'required')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("language_lbl")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-3 form-group">
                  <AsyncPaginate
                    value={this.state.mother_tongue_id}
                    loadOptions={loadOptions}
                    placeholder={t("Form_Mother_Tongue_place")}
                    onChange={this.handleDropdownData.bind(this, "mother_tongue_id")}
                    additional={{
                      endPoint: '/language/'
                    }}
                  />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('Mother Tongue', this.state.mother_tongue_id, 'required')}</span>
                </div>
                <div className="col-md-3 form-group">
                  <AsyncPaginate
                    isMulti
                    value={this.state.languages_known_ids}
                    loadOptions={loadOptions}
                    placeholder={t("Form_languages_know")}
                    onChange={this.handleDropdownData.bind(this, "languages_known_ids")}
                    additional={{
                      endPoint: '/language/'
                    }}
                  />
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("address_lbl")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-3 form-group">
                  <input type="text" className="form-control" autocomplete="new_apartment_no" id="apartment_no" value={this.state.apartment_no} onChange={this.handleInput.bind(this, "apartment_no")} placeholder={t("address_lbl_pla")} name="apartment_no" maxLength="500" />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('Apartment No', this.state.apartment_no, 'required')}</span>
                </div>
                <div className="col-md-3 form-group">
                  <input type="text" className="form-control" autocomplete="new_city" id="city" value={this.state.city} onChange={this.handleInput.bind(this, "city")} placeholder={t("city_lbl")} name="city" maxLength="250" />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('City', this.state.city, 'required')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group"></div>
                <div className="col-md-3 form-group">
                  <input type="text" className="form-control" autocomplete="new_governorate" id="governorate" value={this.state.governorate} onChange={this.handleInput.bind(this, "governorate")} placeholder={t("governorate_pla")} name="governorate" maxLength="500" />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('governorate', this.state.governorate, 'required')}</span>
                </div>
                <div className="col-md-3 form-group">
                  <input type="text" className="form-control" autocomplete="new_zip" id="zip" value={this.state.zip} onChange={this.handleNumInput.bind(this, "zip")} placeholder={t("zipcode_pla")} name="zip" maxLength="6" />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('zipcode', this.state.zip, 'integer')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("phone_lbl")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-6 form-group float-md-right">
                  <PhoneInput
                    countryCodeEditable={false}
                    country={'eg'}
                    value={this.state.phone}
                    enableSearch="true"
                    onChange={phone => this.setState({ phone })}
                  />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('phone', this.state.phone, 'required')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("mobile_lbl")}</b><span style={{ color: "#b80b0b" }}> *</span></label>
                </div>
                <div className="col-md-6 form-group">
                  <PhoneInput
                    countryCodeEditable={false}
                    country={'eg'}
                    value={this.state.mobile}
                    enableSearch="true"
                    onChange={mobile => this.setState({ mobile })}
                  />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('mobile', this.state.mobile, 'required')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("email_lbl")}</b></label>
                </div>
                <div className="col-md-6 form-group">
                  <input type="text" className="form-control" autocomplete="off" id="email" value={this.state.email} onChange={this.handleInput.bind(this, "email")} placeholder={t("email_pla")} name="email" maxLength="75" />
                  <span style={{ color: "#ff0000" }}>{this.validator.message('email', this.state.email, 'email|not_regex:[A-Z]')}</span>
                </div>
              </div>
              <div className="row ml-5">
                <div className="col-md-3 form-group">
                  <label className={`${label_style}`}><b>{t("student_photo")}</b>&nbsp;&nbsp;&nbsp;</label>
                </div>
                <div className="col-md-6 form-group">
                  <div class="custom-file">
                    <input autoComplete="off" type="file" name="profile_img" class="custom-file-input" accept=".jpg,.jpeg,.png" onChange={this.onDropImages.bind(this, "profile_img")} />
                    <label class="custom-file-label" for="exampleInputFile">{(this.state.profile_img_fileName !== '' && this.state.profile_img_fileName !== undefined) ? this.state.profile_img_fileName : t("student_file_upload")}</label>
                    <b>{t("Common_note")}:</b> <span>{t("Form_Note")}</span>
                  </div>
                </div>
              </div>

              <Col sm="12" style={{ backgroundColor: 'aliceblue', }} className="pt-3 text-center pb-3">
                <FormGroup check className="checkbox">
                  <Input className="form-check-input" type="checkbox" id="app_confirm" name="app_confirm" value="yes" checked={this.state.app_confirm === "yes"} onChange={this.handleData.bind(this)} disabled={this.state.disableInput} />
                  <Label check className="form-check-label" htmlFor="app_confirm">&nbsp; {t("term_con_1")} <b><a href="#" title={t("Form_terms_condition")} onClick={() => { this.setState({ modal: true }) }}>{t("term_con_2")}</a></b> {t("term_con_3")}. </Label>
                </FormGroup>
                {this.state.app_confirm !== "yes" ? <span style={{ color: "#ff0000" }}>{this.state.app_confirm_err}</span> : ""}
              </Col>


              {/* <div className="row ml-5">
    	            	<div className="col-md-3 form-group">
    	            		<label className={`${label_style}`}><b>{t("enrolment_type_lbl")}</b><span style={{color:"#b80b0b"}}> *</span></label>
    	            	</div>
    	            	<div className="col-md-6 form-group" style={{zIndex: "999"}}>
    	            		 <Select
                                  value={this.state.enrollment_type}
                                  options={this.state.enrolment_types}
                                  placeholder={t("enrolment_type_select")}
                                  onChange={this.handleDropdownData.bind('this',"enrollment_type")}
                              />
                              <span style={{color:"#ff0000"}}>{this.validator.message('Enrollment Type', this.state.enrollment_type, 'required')}</span>
    	            	</div>
    	            </div>
                  
                     this.state.enrollment_type.value === "sponsored" ?
                      <div className="row ml-5">
                          <div className="col-md-3 form-group">
                            <label className={`${label_style}`}><b>{t("org_name")}</b></label>
                          </div>
                          <div className="col-md-6 form-group">
                            <input type="text" className="form-control" id="org_name" value={this.state.org_name} onChange={this.handleInput.bind(this,"org_name")} placeholder={t("org_name_pla")} name="org_name" maxLength="75" />
                          </div>
                      </div>
                      :
                      ""
    	            <div className="row ml-5">
    	            	<div className="col-md-3 form-group">
    	            		<label className={`${label_style}`}><b>{t("pre_course_lbl")}</b></label>
    	            	</div>
    	            	<div className="col-md-9 form-group">
    	            	    {  this.state.pre_course_types.map(res => {
    	                            return(
    	                            	<label className="radio-inline ml-2">
    	                            	  <input className="mr-1" type="radio" id="pre_course" name="pre_course" value={res.value} checked={this.state.pre_course === res.value} onChange={this.handleInput.bind(this,"pre_course")} />
    	                            	  {res.value}
    	                            	</label>
    	                            )
                                })
                            }
    	            	</div>
    	            </div>*/}
            </div>
            <div className="card-footer mt-3 mb-3">
              <center>
                <button type="submit" className="btn btn-lg btn-primary btn-behance-1" title={t("form_sub_pla")}>{t("form_sub_lbl")}</button>
              </center>
            </div>
          </div>
          <br /><br />
        </div>
      </form>
    )
  }
}

export default withTranslation()(EnrolmentForm)